import { ChevronLeft, ChevronRight } from 'lucide-react';
import BrandMark from '../common/BrandMark';
import SidebarNavigation from './SidebarNavigation';
import { classNames } from '../../utils/classNames';

function AdminSidebar({ collapsed, onToggle }) {
  return (
    <aside
      className={classNames(
        'fixed inset-y-0 left-0 z-40 hidden flex-col border-r border-white/10 bg-primary-950 transition-[width] duration-300 lg:flex',
        collapsed ? 'w-[76px]' : 'w-64'
      )}
    >
      <div className={classNames('flex h-16 items-center border-b border-white/10', collapsed ? 'justify-center px-3' : 'px-5')}>
        {collapsed ? (
          <span className="grid size-9 place-items-center rounded-xl bg-primary-400 font-bold text-slate-950">V</span>
        ) : (
          <BrandMark />
        )}
      </div>
      <div className="flex min-h-0 flex-1 flex-col pt-4">
        <SidebarNavigation collapsed={collapsed} />
      </div>
      <button
        type="button"
        onClick={onToggle}
        className="absolute -right-3 top-20 grid size-7 place-items-center rounded-full border bg-white text-content-muted shadow-card transition hover:text-content-primary"
        aria-label={collapsed ? 'Expandir menú lateral' : 'Plegar menú lateral'}
      >
        {collapsed ? <ChevronRight className="size-4" /> : <ChevronLeft className="size-4" />}
      </button>
    </aside>
  );
}

export default AdminSidebar;
